import { useEffect, useState } from "react";
import Get from "../../api/Get";
import {
  MEDICAL_HISTORY,
  MEDICAL_HISTORY_MX_ADD,
  MEDICAL_HISTORY_MX_GET_BY_ID,
  MEDICAL_HISTORY_MX_UPDATE,
} from "../../api/Routes";
import SimpleLoad from "../../loader/SimpleLoad";
import {
  Accordion,
  Alert,
  Button,
  Card,
  Col,
  Form,
  Row,
} from "react-bootstrap";
import { RiPencilFill } from "react-icons/ri";
import { BsPlusCircleFill } from "react-icons/bs";
import QuestionTemplate from "../QuestionTemplate";
import Post from "../../api/Post";
import Put from "../../api/Put";
import { withTranslation } from "react-i18next";
import { getElementoInside } from "../../utils/getElementoInside";

function ExpedienteMedicoMex({
  appointmentId,
  auth,
  idHM,
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  reload,
  setReload,
}) {
  const [medical, setMedical] = useState([]);
  const [preguntas, setPreguntas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rechckedMH, setRecheckMH] = useState(true);
  const [idHistoriaClinica, setIdHistoriaClinica] = useState(idHM);
  const [showForm, setShowForm] = useState(false);
  const [errorTextDiag, setErrorTextDiag] = useState(null);
  const [respuesta, setRespuesta] = useState([]);
  const [doSave, setDoSave] = useState(false);

  useEffect(() => {
    //console.log('entroaqui')
    let id = idHistoriaClinica ? idHistoriaClinica : idHM;
    //console.log(reload)
    //console.log(id)
    if ((id && rechckedMH) || (id && reload)) {
      let mounted = true;
      setLoading(true);
      Get({
        url: `${MEDICAL_HISTORY_MX_GET_BY_ID}/${id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          console.log(response);
          if (mounted) {
            setMedical(response.data.data.questionsDTOList);
            setLoading(false);
            setRecheckMH(false);
            //checamos si el paciente tiene incapacidad

            setReload(false);
          } else {
            setLoading(false);
            setReload(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          setShowModalServer(true);
          setReload(false);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
      return () => (mounted = false);
    }
  }, [idHM, idHistoriaClinica, rechckedMH, reload]);

  //De donde sacamos las preguntas del historial medico
  useEffect(() => {
    //console.log('reload')
    //console.log(reload)
    let mounted = true;
    setLoading(true);
    Get({
      url: `${MEDICAL_HISTORY_MX_GET_BY_ID}`,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        console.log(response);
        if (mounted) {
          setPreguntas(response.data.data.response);
          setReload(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
        setReload(false);
      });
    return () => (mounted = false);
  }, [reload]);

  const handleShowEditForm = () => {
    setErrorTextDiag("");
    let arr = [...preguntas];
    medical[0].questionOfGroupDTOS.forEach((element) => {
      let index = arr[0].questions.findIndex((e) => e.id === element.id);
      if (index >= 0) {
        arr[0].questions[index].qualifications = element.qualificationDTOS;
        arr[0].questions[index].note = element.note;
      }
    });
    setPreguntas(arr);
    setShowForm(true);
  };
  const handleShowForm = () => setShowForm(!showForm);

  const buildJson = (valor, idPregunta) => {
    const data = {
      id: idPregunta,
      note: "",
      qualificationDTOS: [
        {
          id: valor,
        },
      ],
    };

    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      arr[index] = data;
      setRespuesta(arr);
    } else {
      setRespuesta((respuesta) => [...respuesta, data]);
    }

    //actualizar la pregunta
    let arrP = [...preguntas];
    let indexPre = preguntas[0].questions.findIndex(
      (el) => el.id === idPregunta
    );
    if (indexPre >= 0) {
      let a = arrP[0].questions[indexPre].qualifications.map((el) => ({
        ...el,
        selected: "",
      }));
      arrP[0].questions[indexPre].qualifications = a;
      let indexQ = arrP[0].questions[indexPre].qualifications.findIndex(
        (el) => el.id === parseInt(data.qualificationDTOS[0].id)
      );
      if (indexQ >= 0) {
        arrP[0].questions[indexPre].qualifications[indexQ].selected =
          "selected";
      }
    }
  };

  const builJsonText = (valor, idPregunta) => {
    const data = {
      id: idPregunta,
      note: valor,
    };
    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      arr[index] = data;
      setRespuesta(arr);
    } else {
      setRespuesta((respuesta) => [...respuesta, data]);
    }
    //le respondemos la pregunta
    let arrP = [...preguntas];
    let indexPre = preguntas[0].questions.findIndex(
      (el) => el.id === idPregunta
    );
    if (indexPre >= 0) {
      arrP[0].questions[indexPre]["note"] = valor;
      setPreguntas(arrP);
    }
  };

  const builJsonMultiple = (checked, valor, idPregunta) => {
    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      const index2 = arr[index].qualificationDTOS.findIndex(
        (item) => item.id === valor
      );
      if (checked) {
        const d = {
          id: valor,
        };
        let arr3 = [...arr[index].qualificationDTOS, d];
        arr[index].qualificationDTOS = arr3;
        setRespuesta(arr);
      } else {
        if (index2 >= 0) {
          arr[index].qualificationDTOS.splice(index2, 1);
        }
      }
    } else {
      if (checked) {
        const data = {
          id: idPregunta,
          note: "",
          qualificationDTOS: [
            {
              id: valor,
            },
          ],
        };
        setRespuesta((respuesta) => [...respuesta, data]);
      }
    }

    //le respondemos la pregunta
    let arrP = [...preguntas];
    let indexPre = arrP[0].questions.findIndex((el) => el.id === idPregunta);
    if (indexPre >= 0) {
      let indQ = arrP[0].questions[indexPre].qualifications.findIndex(
        (el) => el.id === parseInt(valor)
      );
      let arrMutar = [...arrP[0].questions[indexPre].qualifications];
      if (checked) {
        arrMutar[indQ].selected = "selected";
        arrMutar[indQ].checked = true;
      } else {
        arrMutar[indQ].selected = null;
        arrMutar[indQ].checked = null;
      }

      arrP[0].questions[indexPre].qualifications = arrMutar;
      setPreguntas(arrP);
    }
  };

  const onClickEnviar = (kForm) => {
    const respuestaLast = [...respuesta];
    //console.log(respuesta)
    if (
      respuestaLast.filter((r) => r.id === 114 && r.note === "N/A").length > 0
    ) {
      if (respuestaLast.filter((r) => r.id === 148).length > 0) {
        let idx = respuestaLast.findIndex((r) => r.id === 148);
        respuestaLast[idx].qualificationDTOS = [{ id: 46 }];
      } else {
        const data = {
          id: 148,
          note: "",
          qualificationDTOS: [
            {
              id: 46,
            },
          ],
        };
        respuestaLast.push(data);
      }
    }
    setErrorTextDiag(null);
    const data = {
      id: null,
      appointmentId: appointmentId,
      questionOfGroupDTOS: respuestaLast,
    };
    console.log(data);
    setLoading(true);
    Post({
      url: MEDICAL_HISTORY_MX_ADD,
      data: data,
      header: true,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        setRecheckMH(true);
        setIdHistoriaClinica(response.data.data.id);
        if (!kForm) {
          setShowForm(!showForm);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
  };

  const handleEditEnviar = (kForm) => {
    let arr = [...respuesta];
    let arrCasillas = preguntas[0].questions.filter(
      (el) => el.questionType.tipoPregunta.id === 2
    );
    if (arrCasillas.length > 0) {
      let arrChecked = getElementoInside(arrCasillas, arr);
      arrChecked.forEach((element) => {
        let index = arr.findIndex((e) => e.id === element.id);
        if (index >= 0) {
          arr[index].qualificationDTOS = element.checked;
        } else {
          const dAux = {
            id: element.id,
            note: "",
            qualificationDTOS: element.checked,
          };
          arr.push(dAux);
        }
      });
    }
    const data = {
      id: idHM,
      appointmentId: appointmentId,
      questionOfGroupDTOS: arr,
    };

    console.log(data);

    setLoading(true);
    Put({
      url: MEDICAL_HISTORY_MX_UPDATE,
      data: data,
      header: true,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        setIdHistoriaClinica(response?.data?.data?.id);
        if (!kForm) {
          setShowForm(!showForm);
        }
        setRecheckMH(true);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
  };

  return (
    <div className="p-3 pt-4 position-relative">
      {loading && <SimpleLoad />}
      {!showForm && (idHM || idHistoriaClinica) && (
        <Button
          variant="outline-info"
          className="position-absolute right-absolute"
          size="sm"
          onClick={handleShowEditForm}
        >
          <RiPencilFill />
        </Button>
      )}

      {!showForm && (
        <>
          {!idHistoriaClinica && !idHM && (
            <div className="cita-btn-add-container" onClick={handleShowForm}>
              <BsPlusCircleFill className="cita-btn-add-item" /> &nbsp;
              <Button variant="outline-primary" type="button" size="sm">
                Crear expediente médico
              </Button>{" "}
            </div>
          )}

          {(idHistoriaClinica || idHM) &&
            medical.map(
              (item, i) =>
                item.questionOfGroupDTOS.length > 0 && (
                  <div key={i}>
                    <label className="font-weight-bold font-size-08rem mb-1 text-secondary">
                      {item.questionGroup}
                    </label>
                    <ul className="list-unstyled font-size-08rem pl-3 color-989898">
                      {item.questionOfGroupDTOS.map((subIt, subI) => (
                        <li key={subI}>
                          <span className="font-weight-bold-600">
                            {subIt.label}:{" "}
                          </span>
                          {subIt.qualificationDTOS.length > 0
                            ? subIt.qualificationDTOS.filter(
                                (q) => q?.selected === "selected"
                              )[0]?.label
                            : subIt.note}
                        </li>
                      ))}
                    </ul>
                  </div>
                )
            )}
        </>
      )}
      {showForm && (
        <Form className="mt-3">
          {errorTextDiag && (
            <Alert variant="danger" className="p-1">
              {errorTextDiag}
            </Alert>
          )}

          {preguntas.map((pregunta, p) => {
            return pregunta?.questions.length > 0 ? (
              <Row
                className="historia-clinica-questions-container"
                key={`pregunta-${p}`}
              >
                <Col>
                  <Accordion defaultActiveKey={p === 0 ? "0" : ""}>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle
                          as={Button}
                          variant="link"
                          eventKey="0"
                        >
                          {pregunta?.questionGroup}
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          {pregunta?.questions.map((question, q) => {
                            return (
                              <Form.Group key={q}>
                                <Form.Label>
                                  {question.questionType?.label}
                                </Form.Label>
                                <QuestionTemplate
                                  questionId={question.id}
                                  questionType={question.questionType}
                                  qualifications={question.qualifications}
                                  buildJson={buildJson}
                                  builJsonText={builJsonText}
                                  builJsonMultiple={builJsonMultiple}
                                  isUpdate={false}
                                  note={question.note}
                                  setDoSave={setDoSave}
                                />
                              </Form.Group>
                            );
                          })}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </Col>
              </Row>
            ) : (
              <div key={`pregunta-${p}`}></div>
            );
          })}

          <Row className="grupoBotones">
            <Col>
              <Button
                variant="danger"
                className="cancelar-buttom"
                type="button"
                onClick={handleShowForm}
              >
                {" "}
                Cancelar{" "}
              </Button>{" "}
            </Col>
            <Col className="text-right">
              {idHM || idHistoriaClinica ? (
                <Button
                  variant="outline-success"
                  className="ok-buttom"
                  type="button"
                  onClick={() => {
                    handleEditEnviar(false);
                  }}
                >
                  Aceptar
                </Button>
              ) : (
                <Button
                  variant="outline-success"
                  className="ok-buttom"
                  type="button"
                  onClick={() => {
                    onClickEnviar(false);
                  }}
                >
                  Aceptar
                </Button>
              )}
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
}

export default withTranslation()(ExpedienteMedicoMex);
